<!-- 用户功能 - 重置密码 -->

<template>
  <div>
    <div class="Reset-content">
      <div class="Reset-content-title">
        <ul class="clearfix">
          <li class="active">安全验证</li>
          <li>重置密码</li>
          <li>修改成功</li>
        </ul>
        <div class="line">
          <span class="One"></span>
          <span class="Two"></span>
          <span class="Three"></span>
        </div>
      </div>
      <div class="Reset-content-tab">
        <!-- tab Start -->
        <ul class="list clearfix">
          <li class="item" :class="{ active: Toggle }" @click="tabToggle(true)">
            手机号找回
          </li>
          <li class="item" :class="{ active: Flog }" @click="tabToggle(false)">
            邮箱找回
          </li>
        </ul>
        <!-- tab End -->

        <!-- Phone Start -->
        <div class="form" v-if="Toggle">
          <div class="form-phone">
            <input
              type="text"
              class="phone"
              placeholder="输入手机号"
              v-model="phone"
            />
          </div>
          <div class="form-code clearfix">
            <input
              type="text"
              class="code"
              placeholder="验证码"
              v-model="code"
              @keydown.enter="submit(true)"
            />
            <input
              type="button"
              :disabled="BtnDisabled"
              :value="BtnCode"
              class="getCode"
              @click="getCode"
            />
          </div>
          <div class="form-btn">
            <input type="button" :value="SubmitBtn" @click="submit(true)" />
          </div>
        </div>
        <!-- Phone Start -->

        <!-- Email Start -->
        <div class="form" v-else>
          <div class="form-email">
            <input
              type="text"
              class="email"
              placeholder="注册邮箱"
              v-model="email"
              @keydown.enter="submit(false)"
            />
          </div>
          <p class="_submit">
            <input type="button" value="验证邮箱" @click="submit(false)" />
          </p>
        </div>
        <!-- Email Start -->
      </div>
    </div>
    <!-- Modal Stsart -->
    <MsgModal></MsgModal>
    <!-- Modal End -->
  </div>
</template>
<script>
//  	import axios from 'axios'
// 模态框UI组件
// 调用时候使用这两句代码：
import MsgModal from "../common/MsgModal";
export default {
  components: { MsgModal },
  data() {
    return {
      Toggle: true,
      Flog: false,
      phone: "",
      code: "",
      email: "",
      BtnCode: "发送验证码",
      SubmitBtn: "下一步",
      timer: 60,
      BtnDisabled: false,
      Reg: {
        phone: /^1[34578]\d{9}$/,
        email:
          /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
        Modal: false,
        tel: "",
      },
    };
  },
  methods: {
    tabToggle(blog) {
      blog ? (this.Toggle = true) : (this.Flog = true);
      blog ? (this.Flog = false) : (this.Toggle = false);
    },
    getCode() {
      var _this = this;
      if (!this.Reg.phone.test(this.phone)) {
        this.$store.dispatch("showMsgModal", {
          autoClose: true,
          info: "请输入正确的手机号码",
        });
      } else {
        this.BtnDisabled = true;
        this.$axios
          .get("/webapi/user/sendPhoneVerifyCodeR", {
            params: {
              account: _this.phone,
              type: 2,
            },
          })
          // 20张图片
          .then((res) => {
            // console.log(res);
            if (res.data.code === 200) {
              let timer = setInterval(() => {
                this.BtnCode = this.timer--;
                if (this.BtnCode <= 0) {
                  clearInterval(timer);
                  this.BtnCode = "发送验证码";
                  this.timer = 60;
                  this.BtnDisabled = false;
                }
              }, 1000);
            } else {
              this.$store.dispatch("showMsgModal", {
                autoClose: false,
                info: res.data.message,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    closeModal() {
      this.Reg.Modal = false;
    },
    submit(blog) {
      var _this = this;
      if (blog) {
        if (this.phone == "" || this.phone == null) {
          this.$store.dispatch("showMsgModal", {
            autoClose: true,
            info: "手机号码不可为空",
          });
          return;
        } else if (this.code == "" || this.code == null) {
          this.$store.dispatch("showMsgModal", {
            autoClose: true,
            info: "验证码不可为空",
          });
          return;
        }
        // 假如用户是phone的话
        this.$axios
          .get("/webapi/user/checkPhoneVerifyCode", {
            params: {
              account: _this.phone,
              phoneVerifyCode: _this.code,
              type: 2,
            },
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code === 200) {
              this.$router.push({
                path: "/reset/confirm",
                query: { account: _this.phone },
              });
            } else {
              this.$store.dispatch("showMsgModal", {
                autoClose: true,
                info: res.data.message,
              });
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      } else {
        if (this.email == "" || this.email == null) {
          this.$store.dispatch("showMsgModal", {
            autoClose: true,
            info: "邮箱不可为空！",
          });
          return;
        }
        // 假如是邮箱的话
        if (!this.Reg.email.test(this.email)) {
          this.$store.dispatch("showMsgModal", {
            autoClose: true,
            info: "请输入正确的邮箱地址！",
          });
        } else {
          this.$axios
            .get("/webapi/user/sendEmailRetrievePwd", {
              params: {
                account: this.email,
              },
            })
            .then((res) => {
              if (res.data.code == "200") {
                this.$router.push({
                  path: "/reset/JumpMail",
                  query: { mail: this.email },
                });
              } else {
                this.$store.dispatch("showMsgModal", {
                  autoClose: false,
                  info: res.data.message,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
  },
};
</script>
<style scoped>
.One {
  background-color: rgb(183, 29, 42);
}
.Two {
  background-color: #ccc;
}
.Three {
  background-color: #ccc;
}
.exit {
  opacity: 0 !important;
  pointer-events: none !important;
}
.start {
  opacity: 1 !important;
  pointer-events: auto !important;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *+height: 1%;
}
/*Content Start*/
.Reset-content {
  width: 640px;
  height: 400px;
  margin: 70px auto 0 auto;
}
.Reset-content > .Reset-content-title {
  height: 60px;
}
.Reset-content-title > ul > li {
  width: 33.3%;
  float: left;
  text-align: center;
}
.Reset-content-title > ul > .active {
  color: #b71d2a;
}
.line {
  width: 430px;
  height: 15px;
  border-bottom: solid 1px #d0d0d0;
  position: relative;
  margin-top: 5px;
  margin: 0 auto;
}
.line > span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #b71d2a;
  position: absolute;
  bottom: -7px;
}
.line > span:nth-child(1) {
  left: 0px;
  background-color: #b71d2a;
}
.line > span:nth-child(2) {
  left: 50%;
  background-color: #ccc;
  transform: translate(-50%, 0);
}
.line > span:nth-child(3) {
  right: 0px;
  background-color: #ccc;
}
.Reset-content > .Reset-content-tab {
  width: 370px;
  margin: 0 auto;
}
.list {
  line-height: 50px;
  border-bottom: solid 1px #909090;
}
.item {
  float: left;
  width: 185px;
  text-align: center;
  cursor: pointer;
}
.Reset-content-tab .active {
  border-bottom: solid 3px #b42533;
}
.form {
}
.form-phone,
.form-email {
  margin-top: 40px;
}
.form-phone > input,
.form-email > input {
  width: 363px;
}
.phone,
.code,
.email {
  height: 42px;
  border: solid 1px #909090;
  border-radius: 3px;
  line-height: 42px;
  padding-left: 14px;
  box-sizing: border-box;
}
.form-code {
  margin-top: 30px;
}
.code {
  width: 239px;
  float: left;
}
.getCode {
  float: left;
  width: 114px;
  height: 42px;
  border: solid 1px #b71d2a;
  color: #b71d2a;
  border-radius: 3px;
  background-color: #fff;
  margin-left: 8px;
  box-sizing: border-box;
  cursor: pointer;
}
.form-btn,
._submit {
  margin-top: 33px;
}
.form-btn > input,
._submit > input {
  background-color: #b71d2a;
  width: 100%;
  border: solid 1px #fff;
  height: 44px;
  color: #fff;
  cursor: pointer;
}
/*End*/
</style>



// WEBPACK FOOTER //
// Validate.vue?1fa3c6a1